// 获取涨跌幅数据
export const GETRISEDROPDATA = 'get-rise-drop-data'
// 获取搜索行情数据
export const GETSEARCHMARKETDATA = 'get-search-market-data'
